"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Transformation = exports.Transformation = function Transformation() {
    var scale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var originX = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var originY = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    _classCallCheck(this, Transformation);

    _initialiseProps.call(this);

    this.scale_ = scale;
    this.originX = originX;
    this.originY = originY;
}

/**
 * Zoom by the given factor around the point (clickX, clickY).
 * This means that the point (clickX, clickY) stays in the same position after the zoom
 *
 * @param factor
 * @param clickX
 * @param clickY
 */


/**
 * Zoom around the center of the dragged rectangle.
 *
 * Implementation details:
 * We want to find the equivalent of this operation in terms of the zoom function we already have.
 * Therefore once we calculate the zoom scale, we also need to find which point stays fixed with this operation
 * Rectangular zoom is done in 3 steps
 * 1) move the center of the rectangle to (0, 0)
 *     (x, y) -> (x - centerX, y - centerY)
 * 2) scale
 *            -> scale*(x - centerX, y - centerY)
 * 3) move so that the top left corner of the rectangle becomes (0, 0)
 *    Per previous two steps, the corner of the rectangle is at scale*(cornerX - centerX, cornerY - centerY)
 *    Thus, the new move bring our (x, y) point to
 *            -> scale*(x - centerX, y - centerY) - scale*(cornerX - centerX, cornerY - centerY)
 *             = scale*(x - cornerX, y - cornerY)
 * To find the fixed point we solve
 *    x = scale*(x - cornerX) and y = scale*(y - cornerY)
 * Which gives us
 *    fixedX = scale / (scale - 1) * cornerX
 *    fixedY = scale / (scale - 1) * cornerY
 *
 * @param x1 x-coordinate of the corner of the rectangle
 * @param y1 y-coordinate of the corner of the rectangle
 * @param x2 x-coordinate of the diagonally opposite corner of the rectangle
 * @param y2 y-coordinate of the diagonally opposite corner of the rectangle
 * @param width the width of the canvas
 * @param height the height of the canvas
 * @param maxZoom maximum allowed zoom
 */
;

Transformation.fromJs = function (obj) {
    return new Transformation(obj.scale || obj.scale_, obj.originX, obj.originY);
};

var _initialiseProps = function _initialiseProps() {
    var _this = this;

    this.scale = function (factor) {
        return new Transformation(_this.scale_ * factor, _this.originX, _this.originY);
    };

    this.translate = function (shiftX, shiftY) {
        return new Transformation(_this.scale_, _this.originX + _this.scale_ * shiftX, _this.originY + _this.scale_ * shiftY);
    };

    this.combine = function (tr) {
        return new Transformation(_this.scale_ * tr.scale_, _this.originX * tr.scale_ + tr.originX, _this.originY * tr.scale_ + tr.originY);
    };

    this.zoom = function (factor, clickX, clickY) {
        return new Transformation(_this.scale_ * factor, clickX - factor * (clickX - _this.originX), clickY - factor * (clickY - _this.originY));
    };

    this.zoomRectangle = function (x1, y1, x2, y2, width, height) {
        var maxZoom = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 1000;

        var centerX = (x1 + x2) / 2;
        var centerY = (y1 + y2) / 2;
        var rectWidth = Math.abs(x1 - x2);
        var rectHeight = Math.abs(y1 - y2);

        var scale = Math.min(Math.min(width / rectWidth, height / rectHeight), maxZoom);
        if (scale === 1) {
            return _this;
        }
        var cornerX = centerX - rectWidth / 2;
        var cornerY = centerY - rectHeight / 2;
        var fixedPointX = scale / (scale - 1) * cornerX;
        var fixedPointY = scale / (scale - 1) * cornerY;
        return _this.zoom(scale, fixedPointX, fixedPointY);
    };

    this.move = function (fromX, fromY, toX, toY) {
        toX = _this.transformedX(toX);
        toY = _this.transformedY(toY);
        return _this.translate(toX - fromX, toY - fromY);
    };

    this.moveOrig = function (fromOrigX, fromOrigY, toX, toY) {
        var fromX = _this.transformedX(fromOrigX);
        var fromY = _this.transformedY(fromOrigY);
        return _this.move(fromX, fromY, toX, toY);
    };

    this.moveDelta = function (deltaX, deltaY) {
        return _this.translate(deltaX, deltaY);
    };

    this.inverse = function () {
        return new Transformation(1.0 / _this.scale_, -_this.originX / _this.scale_, -_this.originY / _this.scale_);
    };

    this.transformedX = function (x) {
        return (x - _this.originX) / _this.scale_;
    };

    this.transformedY = function (y) {
        return (y - _this.originY) / _this.scale_;
    };

    this.transformX = function (x) {
        return x * _this.scale_ + _this.originX;
    };

    this.transformY = function (y) {
        return y * _this.scale_ + _this.originY;
    };

    this.toJs = function () {
        return { scale: _this.scale_, originX: _this.originX, originY: _this.originY };
    };

    this.equals = function (tr) {
        return tr && _this.scale_ === tr.scale_ && _this.originX === tr.originX && _this.originY === tr.originY;
    };

    this.applyOnContext = function (ctx) {
        ctx.setTransform(_this.scale_, 0, 0, _this.scale_, _this.originX, _this.originY);
    };
};


//////////////////
// WEBPACK FOOTER
// ../rc-canvas/lib/Transformation.js
// module id = 114
// module chunks = 0